module.exports = __webpack_public_path__ + "img/icon5.d4eefd2a.png";